import { render, staticRenderFns } from "./Especialidad.vue?vue&type=template&id=4b40bb4f"
import script from "./Especialidad.vue?vue&type=script&lang=js"
export * from "./Especialidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports